import React, { Component } from "react"
import { connect } from "react-redux"
import { AxiosResponse } from "axios"

import {
    eshopId,
    projectId,
    getTemplateGallery,
} from "app/helpers/api"

import {
    Grid,
    Carousel,
} from "@bdfx/mergado-ui-kit"

import { ProductModelType, Template } from "app/types/model-types";
import { TemplateGalleryType } from "template-edit/components/template-gallery";

import { RandomProduct } from "shape-edit/types";
import PreviewTemplateSVG from "template-edit/containers/preview-template-svg";

interface Props {
    isAlt: boolean
    randomProduct: RandomProduct
}

interface State {
    isLoading: boolean
    templateGallery: TemplateGalleryType[]
    productGallery: ProductModelType[]
    scrollPos: number
    scrollWidth: number
    clientWidth: number
    columnWidth: number
    columnsCount: number
}

class GallerySlideShow extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            isLoading: false,
            templateGallery: null,
            productGallery: null,
            scrollPos: 0,
            scrollWidth: null,
            clientWidth: null,
            columnWidth: ItemWidthPx,
            columnsCount: 1,
        }
    }

    getGallery = () => {
        getTemplateGallery(1, null, 20)
            .then((response: AxiosResponse<TemplateGalleryType[]>) => {
                this.setState({ templateGallery: response.data })
            })
            .catch(e => console.error('cannot get template gallery'))
    }

    componentDidMount() {
        window.addEventListener('resize', this.getColumnWidthAndCount)
        this.getGallery()
    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.getColumnWidthAndCount)
    }

    getColumnWidthAndCount = (): number => {
        const target = document.getElementById('carousel-wrapper')
        if (target) {
            const columnWidth = target.clientWidth ? Math.round(target.clientWidth / Math.floor(target.clientWidth / ItemWidthPx)) : ItemWidthPx
            const columnsCount = Math.round(target.clientWidth / columnWidth)
            target.style.transform = `translate3d(0px, 0px, 0px)`
            this.setState({
                scrollPos: 0,
                clientWidth: target.clientWidth,
                columnWidth: columnWidth,
                columnsCount: columnsCount,
            })

            return columnsCount
        }

        return 1
    }

    handleSelectTemplate = (id: number) => {
        location.href = `/eshop/${eshopId}/project/${projectId}/templates/from-gallery/${id}`
    }

    render() {
        const { randomProduct, isAlt } = this.props
        const { templateGallery } = this.state

        const gallery = templateGallery ?? []
        const chunkSize = 5
        const pages = []
        for (let i = 0; i < gallery.length; i += chunkSize) {
            const chunk = gallery.slice(i, i + chunkSize);
            pages.push(chunk)
        }

        return (
            <Carousel timeout={5} minimal={true}>
                {() => pages.map((page => (
                    <Grid key={`gallery_page_${page}`} autoFlow="column" gap="10px">
                        {page.map((o: TemplateGalleryType, idx: number) => {
                            return <div key={`gallery_page_${page}_item_${idx}`} className="preview" onClick={() => this.handleSelectTemplate(o.id)}>
                                <span className={'clickable'}>
                                    <PreviewTemplateSVG
                                        templateGallery={o}
                                        randomProduct={randomProduct}
                                        isAlt={isAlt}
                                    />
                                </span>
                                <br />
                            </div>
                        })}
                    </Grid>
                )))
                }
            </Carousel>
        )
    }
}

const ItemWidthPx = 200

function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        templates: state.templates,
        randomProduct: state.randomProduct,
    }
}

export default connect(mapStateToProps, {
})(GallerySlideShow)
